/**
 * Reset active hotspot icons when their gallery is hidden.
 */
Astro.hotspotGallery = () => {
    document.querySelectorAll('[data-hotspot-gallery]').forEach((gallery) => {
        const crosshairs = gallery.querySelectorAll('.gallery__crosshair');

        gallery.addEventListener('hotspot.hide', () => {
            crosshairs.forEach((crosshair) => {
                crosshair.classList.remove('gallery__crosshair--active');
            });
        });
    });
};

/**
 * Show and hide tooltip instances in response to native hotspot events.
 */
Astro.hotspotGalleryTooltips = () => {
    document.querySelectorAll('[data-hotspot-gallery--tooltips]').forEach((gallery) => {
        const crosshairs = gallery.querySelectorAll('[data-hotspot-tooltip]');
        tippy(crosshairs, tippyConfig);

        gallery.addEventListener('hotspot.hide', () => {
            crosshairs.forEach((crosshair) => {
                if (crosshair._tippy) {
                    crosshair._tippy.hide();
                }
            });
        });

        crosshairs.forEach((crosshair) => {
            crosshair.addEventListener('crosshair.activated', () => {
                crosshair._tippy.show();
            });
            crosshair.addEventListener('crosshair.deactivated', () => {
                crosshair._tippy.hide();
            });
        });
    });
};

/**
 * Position and toggle product cards belonging to each gallery's hotspots.
 */
Astro.hotspotGalleryProducts = () => {
    document.querySelectorAll('[data-hotspot-gallery--products]').forEach((gallery) => {
        const crosshairs = gallery.querySelectorAll('.gallery__crosshair[data-hotspot-product]');
        const popups = Array.from(gallery.querySelectorAll('.gallery__product'));
        const hiddenClass = 'gallery__product--hidden';
        const buffer = 40;

        gallery.addEventListener('hotspot.hide', () => {
            popups.forEach((popup) => popup.classList.add(hiddenClass));
        });

        crosshairs.forEach((crosshair) => {
            const productPopups = popups.filter((popup) => {
                return popup.dataset.product_id === crosshair.dataset.product_id;
            });

            crosshair.addEventListener('crosshair.activated', () => {
                const container = crosshair.parentElement;
                const crosshairBounds = crosshair.getBoundingClientRect();
                const containerBounds = container.getBoundingClientRect();
                const left = crosshairBounds.left - containerBounds.left - container.clientLeft;
                const top = crosshairBounds.top - containerBounds.top - container.clientTop;

                productPopups.forEach((popup) => {
                    // Hidden cards have no measurable dimensions until displayed.
                    popup.classList.remove(hiddenClass);
                    const popupWidth = popup.offsetWidth;
                    const popupHeight = popup.offsetHeight;
                    let x;
                    let y;

                    if (container.classList.contains('block__image')) {
                        x = left + (crosshair.offsetWidth / 2) - (popupWidth / 2);
                        y = top + (crosshair.offsetHeight / 2) + 20;
                    } else {
                        if (left + popupWidth + buffer < container.offsetWidth) {
                            x = left + buffer + (crosshair.offsetWidth / 2);
                        } else if (left - popupWidth - buffer + (crosshair.offsetWidth / 2) >= 0) {
                            x = left - popupWidth - buffer + (crosshair.offsetWidth / 2);
                        }

                        if (top + popupHeight < container.offsetHeight) {
                            y = top;
                        } else {
                            y = container.offsetHeight - popupHeight - (buffer / 2);
                        }
                    }

                    if (x && y) {
                        popup.style.left = `${x}px`;
                        popup.style.top = `${y}px`;
                    }
                });
            });
            crosshair.addEventListener('crosshair.deactivated', () => {
                productPopups.forEach((popup) => popup.classList.add(hiddenClass));
            });
        });
    });
};
